import React, { useState } from 'react';
import jsPDF from 'jspdf';






import css from './GiftCardPage.module.css';
import { SecondaryButton } from '../../components';
import { FormattedMessage } from 'react-intl';

const giftcardPage2 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082496/socialbnb/assets/giftcardPage/giftcard3.png';

const giftcardPage2EN = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082494/socialbnb/assets/giftcardPage/giftcard3-en.png';

const giftcardPage3 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082493/socialbnb/assets/giftcardPage/giftcard-page3.png';

const giftcardPage3EN = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082490/socialbnb/assets/giftcardPage/giftcard-page3-en.png';

const giftcardPage1 = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082488/socialbnb/assets/giftcardPage/giftcard-page1.png';

const giftcardPage1EN = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082486/socialbnb/assets/giftcardPage/giftcard-page1-en.png';

const GiftCardComponent = props => {
  const { recipientName, senderName, message, amount, giftCode, expirationDate, lang } = props;
  const [downloaded, setDownloaded] = useState(false);


  const handleDownloadPDF = () => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'pt',
      format: 'a3',
    });

    const loadImageAsDataUrl = (src) =>
      fetch(src)
        .then(res => {
          if (!res.ok) throw new Error(`Failed to fetch image: ${src}`);
          return res.blob();
        })
        .then(blob => new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => reject(new Error(`Failed to read image: ${src}`));
          reader.readAsDataURL(blob);
        }));

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    Promise.all([
      loadImageAsDataUrl(lang === 'en' ? giftcardPage1EN : giftcardPage1),
      loadImageAsDataUrl(lang === 'en' ? giftcardPage2EN : giftcardPage2),
      loadImageAsDataUrl(lang === 'en' ? giftcardPage3EN : giftcardPage3),
    ])
      .then(([image1, image2, image3]) => {
        doc.addImage(image1, 'PNG', 0, 0, pageW, pageH);

        doc.addPage();
        doc.addImage(image2, 'PNG', 0, 0, pageW, pageH);

        if (message.split(' ').length > 4) {
          let words = message.split(' ');
          let msg1 = words.slice(0, 4).join(' ');
          let msg2 = words.slice(4).join(' ');
          doc.setFont('Helvetica');
          doc.setFontSize(28);
          doc.setTextColor(28, 120, 129);
          doc.text(`${msg1.toUpperCase()}`, 190, 110);
          doc.text(`${msg2.toUpperCase()}`, 190, 150);
        } else {
          doc.setFont('Helvetica');
          doc.setFontSize(30);
          doc.setTextColor(28, 120, 129);
          doc.text(`${message.toUpperCase()}`, 147, 120);
        }

        doc.setFont('Helvetica');
        doc.setFontSize(140);
        doc.setTextColor(235, 114, 66);
        doc.text(`${amount} €`, 205, 480);
        doc.setFont('Helvetica');
        doc.setFontSize(20);
        doc.setTextColor(28, 120, 129);

        if (lang === 'de') {
          doc.text(`GUTSCHEINCODE: ${giftCode}`, 220, 710);
          doc.text(`GÜLTIG BIS: ${expirationDate}`, 245, 740);
        } else {
          doc.text(`VOUCHER CODE: ${giftCode}`, 220, 710);
          doc.text(`VALID UNTIL: ${expirationDate}`, 245, 740);
        }

        doc.addPage();
        doc.addImage(image3, 'PNG', 0, 0, pageW, pageH);

        doc.save('giftcard.pdf');
      })
      .catch((err) => {
        console.error('PDF generation failed:', err);
      });
  };

  return (
    <div>
      <SecondaryButton
        disabled={downloaded}
        className={css.printBtn}
        onClick={() => {
          setDownloaded(true);
          handleDownloadPDF();
          setTimeout(()=> {
            setDownloaded(false);
          },5000)
        }}
      >
        {downloaded ? (
          <FormattedMessage id="giftcardPage.downloadedBtn" />
        ) : (
          <FormattedMessage id="giftcardPage.downloadBtn" />
        )}
      </SecondaryButton>
    </div>
  );
};

export default GiftCardComponent;
